import { PageHead } from "@/components/UI/atoms/PageHead/PageHead";
import { PortalTemplate } from "@/components/templates/PortalTemplate/PortalTemplate";
import * as React from "react";

export interface INoCustomersProps {}

export function NoCustomers(props: INoCustomersProps) {
	return (
		<PageHead pageTitle="No Shops" pageHead="No Shops">
			<div>{"This user doesn't have any shops associated to them"}</div>
		</PageHead>
	);
}
